import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { isChatEnabledFromStorage } from '../util/chat-feature';

/** Keeps the chat page unreachable for clients that have not enabled the feature. */
@Injectable({
  providedIn: 'root',
})
export class chatEnabledGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    return isChatEnabledFromStorage() ? true : this.router.createUrlTree(['home']);
  }
}
